import { InitPage } from "../index";
import swal from "sweetalert";

class ConfirmDialog {
    constructor() {
        this.confirmation = this.confirmation.bind(this);

        $('.userConfirm').on('click', this.confirmation);
    }

    confirmation(e: JQuery.ClickEvent) {
        e.preventDefault();

        const target = e.currentTarget as HTMLElement;
        if ($(target).attr('disabled') == 'disabled' || $(target).hasClass('disabled'))
          return false;

        let confirmMessage = "";
        let confirmTitle = "Are you sure?";

        if ($(target).data("confirm-message") !== undefined) {
            confirmMessage = $(target).data("confirm-message");
        }

        if ($(target).data("confirm-title") !== undefined) {
            confirmTitle = $(target).data("confirm-title");
        }

        swal({
            title: confirmTitle,
            text: confirmMessage,
            icon: "warning",
            closeOnClickOutside: false,
            className: "sn-m-modal",
            buttons: {
                cancel: {
                    text: "No",
                    value: null,
                    visible: true,
                    className: "sn-btn sn-btn-sm sn-btn-silver",
                    closeModal: true
                },
                confirm: {
                    text: "Yes",
                    value: true,
                    visible: true,
                    className: "sn-btn sn-btn-sm sn-btn-red",
                    closeModal: true
                }
            },
            dangerMode: true,
        }).then((willConfirm) => {
            if (!willConfirm) return;

            $('.userConfirm').off('click', this.confirmation);
            target.click();
            $('.userConfirm').on('click', this.confirmation);
        });

        return false;
    }
}

export function LoadPage() {
    new ConfirmDialog();
}
